import React from 'react'
import PropTypes from 'prop-types'
import { BaseForm as Form } from 'component/base'

export const HikisariTaishoKamoku = props => {
  return (
    <Form.Dropdown.WithAPI
      url='/api/staff/master/kumiai_yakushoku'
      keyName='id'
      valueName='id'
      textName='name'
      {...props}
    />
  )
}

HikisariTaishoKamoku.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
}

HikisariTaishoKamoku.defaultProps = {
  name: 'hikisari_taisho_kamoku_cd_list',
  label: '引去対象科目',
  value: undefined,
}
